// Dynamic robots.txt generator for development environments
export const generateRobotsTxt = () => {
  // Check if we're on a development/preview domain
  const hostname = window.location.hostname
  const isDevDomain = 
    hostname.includes('develop') ||
    hostname.includes('preview') ||
    hostname.includes('staging') ||
    hostname.includes('test') ||
    hostname.includes('.pages.dev') || // Cloudflare Pages preview URLs
    hostname === 'localhost'

  if (isDevDomain) {
    // Block all crawlers on development domains
    return `User-agent: *
Disallow: /

# This is a development/preview environment
# Please visit the production site instead`
  } else {
    // Allow crawlers on production domain
    return `User-agent: *
Allow: /

Sitemap: https://${hostname}/sitemap.xml`
  }
}

// Create dynamic robots.txt endpoint
export const setupDynamicRobots = () => {
  // Only run in browser environment
  if (typeof window === 'undefined') return

  const applyRobotsSettings = () => {
    const hostname = window.location.hostname
    const isDevDomain = 
      hostname.includes('develop') ||
      hostname.includes('preview') ||
      hostname.includes('staging') ||
      hostname.includes('test') ||
      hostname.includes('.pages.dev') ||
      hostname === 'localhost'

    console.log('🔍 Checking environment:', { hostname, isDevDomain })

    if (isDevDomain) {
      console.log('🤖 Development environment detected - robots will be blocked')
      
      // Remove existing robots meta tag first
      const existingRobotsMeta = document.querySelector('meta[name="robots"]')
      if (existingRobotsMeta) {
        existingRobotsMeta.remove()
        console.log('🗑️ Removed existing robots meta tag')
      }
      
      // Add noindex meta tag for extra protection
      const noIndexMeta = document.createElement('meta')
      noIndexMeta.name = 'robots'
      noIndexMeta.content = 'noindex, nofollow, noarchive, nosnippet'
      document.head.appendChild(noIndexMeta)
      console.log('✅ Added noindex robots meta tag')

      // Add X-Robots-Tag equivalent via meta tag
      const xRobotsMeta = document.createElement('meta')
      xRobotsMeta.name = 'googlebot'
      xRobotsMeta.content = 'noindex, nofollow'
      document.head.appendChild(xRobotsMeta)
      console.log('✅ Added noindex googlebot meta tag')
    } else {
      console.log('🌐 Production environment detected - allowing indexing')
      
      // Add production robots meta tag
      const robotsMeta = document.createElement('meta')
      robotsMeta.name = 'robots'
      robotsMeta.content = 'index, follow'
      document.head.appendChild(robotsMeta)
      console.log('✅ Added production robots meta tag')
    }
  }

  // Try to apply immediately if DOM is ready
  if (document.readyState === 'loading') {
    // DOM is still loading, wait for it
    document.addEventListener('DOMContentLoaded', applyRobotsSettings)
  } else {
    // DOM is already ready, apply immediately
    applyRobotsSettings()
  }
}
